var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 27.3307C18.4123 27.3307 20.7261 27.0923 22.8705 26.6553C25.5491 26.1093 26.8884 25.8362 28.1105 24.2649C29.3327 22.6935 29.3327 20.8898 29.3327 17.2821V14.7127C29.3327 11.105 29.3327 9.30122 28.1105 7.72989C26.8884 6.15857 25.5491 5.88557 22.8705 5.33956C20.7261 4.90242 18.4123 4.66406 15.9993 4.66406C13.5864 4.66406 11.2725 4.90242 9.1281 5.33956C6.44956 5.88557 5.1103 6.15857 3.88815 7.72989C2.66602 9.30122 2.66602 11.105 2.66602 14.7127V17.2821C2.66602 20.8898 2.66602 22.6935 3.88815 24.2649C5.1103 25.8362 6.44956 26.1093 9.1281 26.6553C11.2725 27.0923 13.5864 27.3307 15.9993 27.3307Z",
    stroke: "#141B34",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2828 16.4198C21.0849 17.2275 20.0321 17.8077 17.9265 18.9681C15.6363 20.2299 14.4912 20.861 13.5637 20.6179C13.2496 20.5355 12.9603 20.3907 12.7173 20.1943C12 19.6145 12 18.4105 12 16.0026C12 13.5947 12 12.3908 12.7173 11.8108C12.9603 11.6144 13.2496 11.4697 13.5637 11.3873C14.4912 11.1442 15.6363 11.7752 17.9265 13.0372C20.0321 14.1975 21.0849 14.7777 21.2828 15.5854C21.3501 15.8603 21.3501 16.1449 21.2828 16.4198Z",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.31003759bdc1a959522139c3b561aa29.svg";
export { ForwardRef as ReactComponent };